import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { useLang } from "../../lib/i18n";
import { PageTitle, StatusBadge, Spinner } from "../../components/Shell";
import { toast } from "sonner";
import { Check, X } from "lucide-react";

export default function Approvals() {
  const [approvals, setApprovals] = useState(null);
  const [filter, setFilter] = useState("pending");
  const { lang } = useLang();

  const load = () => api.get(`/tenant/approvals${filter ? `?status=${filter}` : ""}`).then((r) => setApprovals(r.data.approvals)).catch(() => {});
  useEffect(() => { load(); }, [filter]);

  const decide = async (ap, decision) => {
    try {
      await api.post(`/tenant/approvals/${ap.approval_id}/decision`, { decision });
      toast.success(decision === "approved" ? "Diluluskan" : "Ditolak");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    }
  };

  if (!approvals) return <Spinner />;

  return (
    <div data-testid="tenant-approvals">
      <PageTitle title={lang === "bm" ? "Kelulusan (Maker-Checker)" : "Approvals (Maker-Checker)"} sub={lang === "bm" ? "Setiap tindakan penting memerlukan semakan kedua" : "Every critical action requires a second review"} />
      <div className="flex gap-2 mb-4">
        {["pending", "approved", "rejected", ""].map((s) => (
          <button key={s || "all"} data-testid={`approval-filter-${s || "all"}`} onClick={() => setFilter(s)}
            className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wide transition-colors ${filter === s ? "bg-brand-deep text-white" : "bg-card border border-brand-deep/15 text-brand-deep"}`}>
            {s || "Semua"}
          </button>
        ))}
      </div>
      <div className="space-y-3">
        {approvals.map((ap) => (
          <div key={ap.approval_id} className="bg-card rounded-xl border border-brand-deep/10 p-5 flex flex-wrap items-center gap-4" data-testid={`approval-row-${ap.approval_id.slice(-6)}`}>
            <div className="flex-1 min-w-[220px]">
              <div className="font-medium text-brand-dark">{ap.title}</div>
              <div className="text-xs text-muted-foreground mt-1">
                Maker: {ap.maker_name} • {fmtDate(ap.created_at)}
                {ap.checker_name && <> • Checker: {ap.checker_name}</>}
              </div>
            </div>
            <StatusBadge status={ap.status} />
            {ap.status === "pending" && (
              <div className="flex gap-2">
                <button data-testid={`approve-${ap.approval_id.slice(-6)}`} onClick={() => decide(ap, "approved")} className="inline-flex items-center gap-1.5 bg-brand-vivid text-white text-xs font-bold px-4 py-2 rounded-lg hover:bg-brand-deep transition-colors">
                  <Check className="w-3.5 h-3.5" /> Lulus
                </button>
                <button data-testid={`reject-${ap.approval_id.slice(-6)}`} onClick={() => decide(ap, "rejected")} className="inline-flex items-center gap-1.5 bg-red-100 text-red-700 text-xs font-bold px-4 py-2 rounded-lg hover:bg-red-200 transition-colors">
                  <X className="w-3.5 h-3.5" /> Tolak
                </button>
              </div>
            )}
          </div>
        ))}
        {approvals.length === 0 && <p className="text-center text-sm text-muted-foreground py-10 bg-card rounded-xl border border-brand-deep/10">Tiada kelulusan {filter}.</p>}
      </div>
    </div>
  );
}
